<div
  class="ml-auto flex w-fit flex-wrap gap-2"
  [attr.data-testid]="'section-header-actions'">
  <ng-content></ng-content>
</div>
